import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CreateUserModal } from "./CreateUserModal";

export function CreateUserButton() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        onClick={() => setIsModalOpen(true)}
        aria-label="create-user-button"
      >
        <PlusCircleOutlined />
        {t("user:create-user")}
      </Button>
      {isModalOpen && (
        <CreateUserModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
      )}
    </>
  );
}
